import { z } from 'zod';

/** Product identifiers are short lowercase slugs; they prefix queues, SQL schemas, AI task ids and translation keys. */
export const productId = z.string().regex(/^[a-z][a-z0-9]{1,30}$/, 'Expected a lowercase product id, e.g. "tenders"');
export type ProductId = z.infer<typeof productId>;

export const organizationId = z.uuid();
export type OrganizationId = z.infer<typeof organizationId>;
